module.exports = __webpack_public_path__ + "static/img/11pelicanvista.com.319ab3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/11pelicanvista.com.jpg
// module id = 29
// module chunks = 1